'use client';
import dynamic from 'next/dynamic';

// ponytail: web component mutates own DOM on upgrade → can't SSR
const Altcha = dynamic(() => import('./Altcha'), { ssr: false });

export default Altcha;
